export default [
  {
    path: "/raporsatis",
    name: "raporsatis",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raporsatis.Baslik",
      yetki: { k: [2001402] },
    },
  },
]
